import React, { useEffect, useState } from 'react';
import PrivatePage from '../base/private';
import {Container, makeStyles, Paper, IconButton, Grid, Button} from '@material-ui/core';
import { fetchCandidateRole, postCandidateRole, updateCandidateRole, deleteCandidateRole } from '../../api/candidateRole';
//import Loader from '../../components/loader';
//import useFetch from '../../hooks/useFetch';
import { COLORS } from '../../constants/colors';
import Section from '../../components/common/section';
import { faTrash, faEdit, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DataGrid} from '@material-ui/data-grid';
import _ from 'lodash';
import Input from '../../components/common/input';
import useDebounce from '../../hooks/useDebounce';
import useNotification from '../../hooks/useNotification';
import AddCandidateRoleModal from '../../components/candidateRole/modal';
import EditCandidateRoleModal from '../../components/candidateRole/modal';
import DeleteModal from '../../components/deleteModal';

const useStyles = makeStyles({
  root: {
    '& .grey--header': {
      backgroundColor: COLORS.grayScale[4],
    },
    '& .action-cell': {
      justifyContent: 'center'
    }
  },
  container: {
    maxWidth: '90rem',
    padding: '2rem 3.125rem',
  },
  loader: {
    paddingTop: '3rem',
  },
  filterContainer: {
    marginBottom: '2.0625rem'
  }
});
 
const CandidateRolePage = () => {
  const classes = useStyles();
  const [ candidateRoles, setCandidateRoles ] = useState(null);
  const [ results, setResults ] = useState([]);
  const [ search, setSearch ] = useState('');
  const [ isLoading, setIsLoading ] = useState(false);
  const [ disabledAdd, setDisabledAdd ] = useState(false);
  const [ disabledEdit, setDisabledEdit ] = useState(false);
  const [ disabledDelete, setDisabledDelete ] = useState(false);
  const [ openAdd, setOpenAdd ] = useState(false);
  const [ openEdit, setOpenEdit ] = useState(false);
  const [ openDelete, setOpenDelete ] = useState(false);
  const [ changes, setChanges ] = useState(0);
  const [ selected, setSelected ] = useState(null);
  const [ page, setPage ] = useState(0);

  const notifications = useNotification();

  const fetchCandidateRolesDebounced = useDebounce(
    (name) => {
      setIsLoading(true);
      setPage(0);
      return fetchCandidateRole(name)
            .ready()
            .then((res) => {
              if (res.success) setResults(res.data);
              else
                notifications.error({
                  message:
                    'An error has occured while searching skills. Please, try again later',
                });
            })
            .finally(() => {
              setIsLoading(false);
            });
    },
    1000
  );

  useEffect(() => {
    fetchCandidateRolesDebounced(search);
  }, [search, changes]);

  useEffect(() => {
    const newCandidateRoles = _.map(results, (candidateRoles) => ({ id: candidateRoles.hash, ...candidateRoles }));
    setCandidateRoles(newCandidateRoles);
  }, [ results ])

  const openModal = (type, selected) => () => {
    switch (type) {
      case 'ADD': 
        setSelected(null);
        setOpenAdd(true);
        break;
      case 'DELETE': 
        setSelected(selected);
        setOpenDelete(true);
        break;
      case 'EDIT': 
        setSelected(selected);
        setOpenEdit(true);
        break;
      default: 
        break;
    }
  }

  const closeModal = (type) => {
    switch (type) {
      case 'ADD': 
        setOpenAdd(false);
        break;
      case 'DELETE': 
        setOpenDelete(false);
        break;
      case 'EDIT': 
        setOpenEdit(false);
        break;
      default: 
        break;
    }
  }

  const handleAdd = (data) => {
    setDisabledAdd(true);
    postCandidateRole({ immediately: true, ...data })
    .then((res) => {
      if(res.success){
        setChanges((prev) => prev + 1)
        notifications.success({message: 'Role created successfully'})
      }else{
        notifications.error(res.error)
      }
    })
    .finally(() => {
      closeModal('ADD');
      setDisabledAdd(false);
    })
  }

  const handleEdit = (data) => {
    setDisabledEdit(true);
    updateCandidateRole(selected?.hash, { immediately: true, ...data })
    .then((res) => {
      if(res.success){
        setChanges((prev) => prev + 1)
        notifications.success({message: 'Role edited successfully'})
      }else{
        notifications.error(res.error)
      }
    })
    .finally(() => {
      closeModal('EDIT');
      setDisabledEdit(false);
    })
  }

  const handleDelete = () => {
    setDisabledDelete(true);
    deleteCandidateRole(selected?.hash, { immediately: true })
    .then((res) => {
      if(res.success){
        setChanges((prev) => prev + 1)
        notifications.success({message: 'Role deleted successfully'})
      }else{
        notifications.error(res.error)
      }
    })
    .finally(() => {
      closeModal('DELETE');
      setDisabledDelete(false);
    })
  }

  const columns = [
    { 
      field: 'name', 
      headerName: 'Candidate Role', 
      headerClassName: 'grey--header', 
      flex: 4 
    },
    {
      field: 'edit',
      headerName: 'Edit',
      headerClassName: 'grey--header',
      cellClassName: 'action-cell',
      headerAlign: 'center',
      flex: 0.5,
      renderCell: (params) => (
          <IconButton
            color="primary"
            onClick={openModal('EDIT', params.row)}
          >
            <FontAwesomeIcon icon={faEdit}/>
          </IconButton>
      ),
    },
    {
      field:'delete',
      headerName: 'Delete',
      headerClassName: 'grey--header',
      headerAlign: 'center',
      cellClassName: 'action-cell',
      flex: 0.5,
      renderCell: (params) => (
          <IconButton
            color="primary"
            onClick={openModal('DELETE', params.row)}
          >
            <FontAwesomeIcon icon={faTrash}/>
          </IconButton>
      ),
    },
  ];

  return (
    <PrivatePage>
      {/* {isLoading && (
        <Loader className={classes.loader} label="Searching skills ..." />
      )} */}
      {candidateRoles && (
        <div className={classes.root}>
          <section>
            <Container className={classes.container}>
              <Section title="Candidate Role">
                <section>
                  <Grid container direction="row" className={classes.filterContainer}>
                    <Grid item xs={4}>
                      <div className={classes.searcher}>
                        <Input
                          value={search}
                          startIcon={<FontAwesomeIcon icon={faSearch} />}
                          placeholder="Search Candidate Role"
                          onChange={({ target }) => setSearch(target.value)}
                        />
                      </div>
                    </Grid>
                    <Grid item style={{ textAlign: 'right' }} xs>
                      <Button variant="contained" color="primary" onClick={openModal('ADD')}>ADD CANDIDATE ROLE</Button>
                    </Grid>
                  </Grid>
                </section>
                <Paper className={classes.root}>
                  <div>
                    <DataGrid
                      isLoading={isLoading}
                      rows={candidateRoles}
                      columns={columns}
                      page={page}
                      onPageChange={(val)=>setPage(val.page)}
                      pageSize={10}
                      autoHeight
                      disableColumnMenu={true}
                      disableSelectionOnClick={true}
                      disableMultipleSelection={true}
                    />
                  </div>
                </Paper>
              </Section>
            </Container>
          </section>
        </div>
      )}
      <AddCandidateRoleModal 
        disabled={disabledAdd} 
        open={openAdd} 
        onClose={() => closeModal('ADD')} 
        onSubmit={handleAdd}
      />
      <EditCandidateRoleModal 
        name={selected?.name}
        edit={true}
        disabled={disabledEdit} 
        open={openEdit} 
        onClose={() => closeModal('EDIT')} 
        onSubmit={handleEdit}
      />
      <DeleteModal 
        open={openDelete} 
        disabled={disabledDelete} 
        onClose={() => closeModal('DELETE')} 
        onSubmit={handleDelete} 
      />
    </PrivatePage>
  );
};

export default CandidateRolePage;
